(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const WORD_LIMIT = 50;

  document.querySelectorAll(".read-more-wrapper").forEach(wrapper => {
    const textEl = wrapper.querySelector(".read-more-text");
    const btn = wrapper.querySelector(".read-more-btn");
    const btnText = btn.querySelector(".btn-text");

    const fullHTML = textEl.innerHTML.trim();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = fullHTML;

    const fullText = tempDiv.textContent || tempDiv.innerText;
    const words = fullText.split(/\s+/);

    if (words.length <= WORD_LIMIT) return;

    const truncatedText = words.slice(0, WORD_LIMIT).join(" ") + "...";

    textEl.setAttribute("data-full", fullHTML);
    textEl.setAttribute("data-truncated", truncatedText);
    textEl.innerText = truncatedText;

    btn.style.display = "inline-flex";
    btnText.textContent = "Read More";

    btn.addEventListener("click", function () {
      const collapsed = textEl.getAttribute("data-collapsed") === "true";

      if (collapsed) {
        textEl.innerHTML = textEl.getAttribute("data-full");
        btnText.textContent = "Read Less";
        btn.classList.add("expanded");
      } else {
        textEl.innerText = textEl.getAttribute("data-truncated");
        btnText.textContent = "Read More";
        btn.classList.remove("expanded");
      }

      textEl.setAttribute("data-collapsed", !collapsed);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
